import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FaceUnhappyOutlineSVG = function FaceUnhappyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,1,2,16,14,14,0,0,1,16,2Zm0,2A12,12,0,1,0,28,16,12,12,0,0,0,16,4Zm5.6,14a1,1,0,1,1,.1,2l-.31,0a21.39,21.39,0,0,0-4.41.82l-.55.18A18.57,18.57,0,0,0,14,22.14c-.42.22-.82.45-1.19.67l-.37.23c-.29.18-.5.31-.6.39a1,1,0,0,1-1.13-1.65L11,21.6l.41-.26c.52-.32,1.09-.65,1.69-1a22.54,22.54,0,0,1,2.26-1l.51-.18a22.73,22.73,0,0,1,5.39-1.09ZM12,11a2,2,0,1,1-2,2A2,2,0,0,1,12,11Zm8,0a2,2,0,1,1-2,2A2,2,0,0,1,20,11Z"
  }));
};
FaceUnhappyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FaceUnhappyOutlineSVG);